import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SkillAvailability } from '../models';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SkillService {

    constructor(private http: HttpClient) { }

    makeSkillAvailable(): void {
        parent.postMessage('uwfSkillAvailable', '*');
    }

    getSkillAvailabilityCheckSeconds() {
        return this.http.get<number>('/api/floatingchat/getskillavailabilitycheckseconds');
    }

    getDefaultSkillAddress() {
        return this.http.get<string>('/api/floatingchat/getdefaultskilladdress');
    }

    getSkillStatus(skillAddresses: string[]) {
        // do not use HttpParams because of the following defect where Angular fails to encode the plus sign
        // https://github.com/angular/angular/issues/11058

        return this.http.get<SkillAvailability[]>(
            '/api/floatingchat/checkskillstatus?addresses=' + encodeURIComponent(skillAddresses.join(',')),
            {
                responseType: 'json'
            }
        );
    }

    hideChatButton(): void {
        parent.postMessage('uwfHideChatButton', '*');
    }
}
